export default "__VITE_ASSET__7xEkeAui__"